const track = document.querySelector('.gallery-track');
const slides = [...document.querySelectorAll('.gallery-slide')];
const previous = document.querySelector('#gallery-prev');
const next = document.querySelector('#gallery-next');
const counter = document.querySelector('#gallery-count');
let activeSlide = 0;
let scrollFrame;

function updateGallery() {
  const left = track.getBoundingClientRect().left;
  activeSlide = slides.reduce((closest, slide, index) => {
    return Math.abs(slide.getBoundingClientRect().left - left) < Math.abs(slides[closest].getBoundingClientRect().left - left) ? index : closest;
  }, 0);
  previous.disabled = track.scrollLeft <= 2;
  next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
  const right = track.getBoundingClientRect().right;
  const visible = slides.map((slide, index) => {
    const rect = slide.getBoundingClientRect();
    return Math.min(rect.right, right) - Math.max(rect.left, left) > rect.width * .55 ? index : -1;
  }).filter(index => index !== -1);
  const first = String((visible[0] ?? activeSlide) + 1).padStart(2, '0');
  const last = String((visible.at(-1) ?? activeSlide) + 1).padStart(2, '0');
  counter.textContent = `${first === last ? first : `${first}–${last}`} / ${String(slides.length).padStart(2, '0')}`;
}

function moveGallery(direction) {
  const target = Math.max(0, Math.min(slides.length - 1, activeSlide + direction));
  const offset = slides[target].getBoundingClientRect().left - track.getBoundingClientRect().left;
  track.scrollBy({ left: offset, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
}

previous.addEventListener('click', () => moveGallery(-1));
next.addEventListener('click', () => moveGallery(1));
track.addEventListener('scroll', () => {
  cancelAnimationFrame(scrollFrame);
  scrollFrame = requestAnimationFrame(updateGallery);
}, { passive: true });
track.addEventListener('keydown', event => {
  if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
    event.preventDefault();
    moveGallery(event.key === 'ArrowRight' ? 1 : -1);
  }
});
window.addEventListener('resize', updateGallery, { passive: true });
updateGallery();

const lightbox = document.querySelector('.lightbox');
const enlargedPhoto = document.querySelector('#lightbox-image');
const photoCaption = document.querySelector('#lightbox-caption');
let photoTrigger;
document.querySelectorAll('[data-photo]').forEach(button => {
  button.addEventListener('click', () => {
    photoTrigger = button;
    const source = button.querySelector('img');
    enlargedPhoto.src = source.dataset.full || source.currentSrc || source.src;
    enlargedPhoto.alt = source.alt;
    photoCaption.textContent = button.closest('figure').querySelector('figcaption > span').textContent;
    lightbox.showModal();
  });
});
document.querySelector('#lightbox-close').addEventListener('click', () => lightbox.close());
lightbox.addEventListener('click', event => {
  if (event.target === lightbox) {
    const bounds = lightbox.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) lightbox.close();
  }
});
lightbox.addEventListener('close', () => photoTrigger?.focus({ preventScroll: true }));
